const routes = {
  getUnits: "accounts/units",
  getMajorCategories: "accounts/majorCategories",
  getSubCategories: "accounts/subCategories",
  getAccountCode: "accounts/code",
  getAccountBySubCategory: "accounts/bySubCategory",
  createAccount: "accounts/add",
  updateAccount: "accounts/update",
  getAccounts: "accounts",
  getAccountsDropDown: "accounts/dropdown",
  getAccountsApprovals: "accounts/approvals",
  approveAccount: "accounts/approve",
  getChartOfAccount: "accounts/coa",
  getCOASubAccounts: "accounts/coa/subAccounts",
  getChartOfAccountLabel: "accounts/coa/list",
  getChartOfAccountSubAccount: "accounts/subAccounts",
  getAccountLedgers: "accounts/ledger",
  getExportAccountLedgers: "export/accounts/ledger",
  getGeneralJournalLedgers: "accounts/generaljournal",
  getVaultCustomers: "accounts/vault/customers",
  getVaultCustomersWithOutToken: "accounts/vault/customersWithOutToken",
  getPaymentAccounts: "accounts/vault/paymentAccounts",
  getVendorTTPaymentAccounts: "accounts/vendorTTAccounts",
  getPaymentAccountsWithOutToken: "accounts/vault/paymentAccountsWithOutToken",
  getVaultTopUps: "accounts/vault/topups",
  createVaultTopUp: "accounts/vault/topup",
  getVaultTopUpDetail: "accounts/vault/topups/details",
  getVaultTopUpPreview: "accounts/vault/topups/preview",
  getAccountReports: "accounts/reports",
  getCashierActivity: "accounts/cashierActivity",
  PaymentVoucher: "accounts/paymentVouchers/add",
  PaymentVoucherV2: "accounts/paymentVouchers/add-v2",
  updatePaymentVoucher: "accounts/paymentVouchers/add",
  reversePaymentVoucher: "accounts/paymentVouchers/reverse",
  getVouchers: "accounts/paymentVouchers",
  getVoucherDetails: "accounts/paymentVouchers/details",
  deleteVoucher: "accounts/paymentVouchers/delete",
  deleteReceipt: "accounts/receiptVouchers/delete",
  deleteIFTV: "accounts/iftVouchers/delete",
  ReceiptVoucher: "accounts/receiptVouchers/add",
  ReceiptVoucherV2: "accounts/receiptVouchers/add-v2",
  UpdateReceiptVoucherV2: "accounts/receiptVouchers/update-v2",
  getReceipts: "accounts/receiptVouchers",
  getReceiptDetail: "accounts/receiptVouchers/details",
  UpdateReceiptVoucher: "accounts/receiptVouchers/add",
  reverseReceiptVoucher: "accounts/receiptVouchers/reverse",
  createJournalVoucher: "accounts/journalVouchers/add",
  getJournalVouchers: "accounts/journalVouchers",
  deleteJournalVoucher: "accounts/journalVouchers/delete",
  getJournalVoucherDetail: "accounts/journalVouchers/details",
  ExportJournalVoucherPreview: "accounts/journalVouchers/preview",
  createFundTransferVoucher: "accounts/iftVouchers/add",
  getFundTransferVouchers: "accounts/iftVouchers/",
  getFundTransferVoucherDetail: "accounts/iftVouchers/details",
  getVehicleSumLedger: "accounts/ledgerReports",
  getVehicleSumLedgerV2: "accounts/ledgerReports-v2",
  getVehicleSumLedgerExport: "export/accounts/ledgerReports",
  getShippingProfit: "clients/shippingProfit",
  getShippingReceiving: "accounts/shippingReceiving",
  getShippingAging: "accounts/shippingReceivableAging",
  getFundTransferApproval: "accounts/iftVouchers/approvals",
  FundTransferApprove: "accounts/iftVouchers/approve",
  AccountBlance: "accounts/balance",
  updateVaultTopUp: "accounts/vault/topup",
  reverseVaultTopUp: "accounts/vault/reverse",
  reverseJV: "accounts/journalVouchers/reverse",
  ReverseIFTVoucher: "accounts/iftVouchers/reverse",
  getReceiptPreview: "accounts/receiptVouchers/preview",
  getVoucherPreview: "accounts/paymentVouchers/preview",
  getJournalVoucherPreview: "accounts/journalVouchers/preview",
  getFundTransferVoucherPreview: "accounts/iftVouchers/preview",
  getPaymentAccountsShipping: "accounts/vault/paymentAccounts/shipping",
  getAllAccountsData: "accounts/accounts",
  getJournalVoucherTemplte: "accounts/jv/templates",
  deleteJournalVoucherTemplate: "accounts/journalVouchers/delete",
  editFundTransferVoucher: "accounts/iftVouchers/update",
  updatePaymentVoucherV2: "accounts/paymentVouchers/update-v2",
  editJournalVoucher: "accounts/journalVouchers/update",
  certifyLedger: "accounts/certifyLedger",
  getCertificationLedgers: "accounts/certificationLedgers",
};

export default routes;
